import { validate, getCardType, countries } from 'utils';
import { useAppContext } from '../../../contexts/AppContext';
import Select from "@/components/elements/Select/Select";
import Input from "@/components/elements/Input/Input";
import CreditCardInput from '@/components/elements/CreditCardInput/CreditCardInput';
import styles from './CardInputsV2.module.scss';
import { useEffect } from 'react';

const CardInputsV2 = ({onValidate=false}) => {

    const { signUpInfo, setSignUpInfo, appLoading } = useAppContext();

    useEffect(() => {
        const cardType = getCardType(signUpInfo.cardNumber?.toString())
        if(onValidate){
            const toValidate = [
                validate.cardNumber(signUpInfo.cardNumber, cardType),
                validate.expiryYear(signUpInfo.year),
                validate.expiryMonth(signUpInfo.month),
                validate.cvv(signUpInfo.cvv),
                validate.notEmpty("Zip code", signUpInfo.zipCode),
                validate.notEmpty("First name", signUpInfo.firstName),
                validate.notEmpty("Last name", signUpInfo.lastName)
           ]
            const isValid = toValidate.every(validation => validation.valid)
            if(isValid){
                onValidate(true)
            }
        }
    }, [signUpInfo, onValidate])


    return (
        <div className={styles.CardInputsV2}>
            <div>
                <CreditCardInput value={signUpInfo.cardNumber} onChange={(cardNumber)=>setSignUpInfo({...signUpInfo, cardNumber, cardType: typeof cardNumber === 'string' || typeof cardNumber === "number" ? getCardType(signUpInfo.cardNumber?.toString()) : null})} theme="v2" disabled={appLoading} />
            </div>
            <div>
                <Input type="number" placeholder="Month (MM)" value={signUpInfo.month} name="month" autoComplete="cc-exp-month"  onChange={(month)=>setSignUpInfo({...signUpInfo, month})} disabled={appLoading} maxLength={2} theme="v2" valid={validate.expiryMonth(signUpInfo.month).valid} />
                <Input type="number" placeholder="Year (YY)" value={signUpInfo.year} name="year" autoComplete="cc-exp-year"  onChange={(year)=>setSignUpInfo({...signUpInfo, year})} disabled={appLoading} maxLength={2} theme="v2" valid={validate.expiryYear(signUpInfo.year).valid} />
                <Input type="number" placeholder="CVV" value={signUpInfo.cvv} name="cvv" autoComplete="cc-csc"  onChange={(cvv)=>setSignUpInfo({...signUpInfo, cvv})} disabled={appLoading} maxLength={signUpInfo.cardType === "amex" ? 4 : 3} theme="v2" valid={validate.cvv(signUpInfo.cvv, signUpInfo.cardType).valid}  />
            </div>
            <div>
                <Input type="text" placeholder="Zip" value={signUpInfo.zipCode} name="zipCode" autoComplete="billing postal-code"  onChange={(zipCode)=>setSignUpInfo({...signUpInfo, zipCode})} disabled={appLoading} theme="v2" valid={validate.notEmpty("Zip code", signUpInfo.zipCode).valid} />
            </div>
            <div>
                <Select type="number"  value={signUpInfo.country} onChange={(country)=>setSignUpInfo({...signUpInfo, country})} disabled={appLoading} theme="v2">
                    {countries.map((country, i)=>
                        <option value={country.name} key={country.name} selected={country.name === signUpInfo.country}>{country.name}</option>
                    )}
                </Select>
            </div>
            <div>
                <Input type="text" placeholder="First name" value={signUpInfo.firstName} disabled={appLoading}  onChange={(firstName)=>setSignUpInfo({...signUpInfo, firstName})} theme="v2" valid={validate.notEmpty("First name", signUpInfo.firstName).valid} />
            </div>
            <div>
                <Input type="text" placeholder="Last name" value={signUpInfo.lastName} disabled={appLoading}  onChange={(lastName)=>setSignUpInfo({...signUpInfo, lastName})} theme="v2" valid={validate.notEmpty("Last name", signUpInfo.lastName).valid} />
            </div>
        </div>
    );
}

export default CardInputsV2;
